import { useFilterData } from '../../../filterContext';
import { IDateRange } from '../../../../../../../api/apiTypes';
import { isEditorDateDifferentFromExternalDate } from './isEditorDateDifferentFromExternalDate';

/**
 * Returns true if the user has changed the date in the editor.
 */
export const useDateSelectorHasChanges = ({
  startDate,
  endDate,
}: IDateRange): boolean => {
  const { startDate: startDateExternal, endDate: endDateExternal } =
    useFilterData().commonFilterState;

  const hasChangesStartDate = isEditorDateDifferentFromExternalDate(
    startDate,
    startDateExternal
  );
  const hasChangesEndDate = isEditorDateDifferentFromExternalDate(
    endDate,
    endDateExternal
  );
  /** Has the user changed anything? */
  const hasChanges = hasChangesStartDate || hasChangesEndDate;

  return hasChanges;
};
